import { gql } from "@apollo/client";

export const GET_DEPOSITOS_BY_ID_EVALUACION = gql`
  query GetDepositosByIdEvaluacion($idEvaluacion: Int!) {
    depositosByIdEvaluacion(idEvaluacion: $idEvaluacion) {
      idDeposito
      idDelegacion
      deposito
      fechaAlta
      centroSAP
      almacenSAP
    }
  }
`;